var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4964_1655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4327 48.9601L46.139 55.6055C47.615 56.3777 49.3385 55.1308 49.0575 53.4965L46.6315 39.4212C46.5202 38.7721 46.7358 38.1106 47.2102 37.6498L57.4904 27.6818C58.6839 26.5249 58.0259 24.5086 56.3761 24.2692L42.1702 22.2156C41.515 22.1215 40.9488 21.7119 40.6567 21.1209L34.3036 8.31465C33.5663 6.82838 31.4351 6.82838 30.6965 8.31465L24.3433 21.1209C24.0498 21.7119 23.4836 22.1201 22.8298 22.2156L8.62395 24.2692C6.97411 24.5073 6.31612 26.5235 7.50968 27.6818L17.7899 37.6498C18.2642 38.1093 18.4799 38.7721 18.3686 39.4212L15.9425 53.4965C15.6601 55.1308 17.3851 56.3777 18.861 55.6055L31.5673 48.9601C32.153 48.6543 32.8527 48.6543 33.4383 48.9601H33.4327Z",
    fill: "#FFC757"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4964_1655",
    x: 6.90002,
    y: 7.19995,
    width: 51.2,
    height: 52.6399,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4964_1655"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4964_1655",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarFilled);
export default __webpack_public_path__ + "static/media/icon-star-filled.2eda6f6efc8251f8545b700f889d8414.svg";
export { ForwardRef as ReactComponent };